import { base } from "@base-provider";
import { API_PARAM } from "../constants/apiParams";

export const getTenantSettings = () => {
  return base.get({
    url: API_PARAM.TENANT_SETTINGS,
  });
};

export const getExposedSPData = () => {
  return base.get({
    url: API_PARAM.BENCHMARK_FILTERING_DATA,
  });
};

export const saveUserAvatar = async (data) => {
  return base.post({ url: API_PARAM.IDENTITY_AVATAR, data });
};